import { useFormikContext } from "formik";
import { handleChangeHelper } from "./formikRadioHelper";
import { useContext } from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";

function useFormikRadio() {
  const field = useContext(FormikControlContext);
  const { arrayIndex, productName } = field;
  const formik = useFormikContext();

  const handleChange = (name, event) => {
    formik.handleChange(event);

    // Calling helper function
    handleChangeHelper(event, productName, arrayIndex, formik);
  };

  const handleBlur = (name, event) => {
    // Calling helper function
    // handleOnBlurHelper();
  };

  return { handleChange, handleBlur };
}

export default useFormikRadio;
